module.exports = __webpack_public_path__ + "img/chr_ts_90_24.dc00b542.png";